import { useAssigneeOptions } from "src/data/taskManagement/hooks/useAssigneeOptions"
import { ComboboxStateful } from "src/ui/Combobox/ComboboxStateful"

export function AssigneeCombobox({
  initialValue,
  onChange,
}: {
  initialValue: string
  onChange: (value: string) => void
}) {
  const { options, initialAssignee, handleSearch } =
    useAssigneeOptions(initialValue)

  return (
    <ComboboxStateful
      initialInput={initialAssignee.label}
      options={options}
      selectedValue={initialAssignee.value}
      onChange={onChange}
      onSearch={handleSearch}
    />
  )
}
